// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Js_null_undefined = require("@rescript/std/lib/js/js_null_undefined.js");

function alt(fa1, fa2) {
  if (fa1 !== undefined) {
    return fa1;
  } else {
    return fa2;
  }
}

function flatten(opt) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  }
  
}

function getWithDefaultLazy(opt, getDefault) {
  if (opt !== undefined) {
    return Caml_option.valFromOption(opt);
  } else {
    return Curry._1(getDefault, undefined);
  }
}

function mapWithDefaultLazy(opt, getDefault, f) {
  if (opt !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(opt));
  } else {
    return Curry._1(getDefault, undefined);
  }
}

var fromNullable = Js_null_undefined.fromOption;

exports.fromNullable = fromNullable;
exports.alt = alt;
exports.flatten = flatten;
exports.getWithDefaultLazy = getWithDefaultLazy;
exports.mapWithDefaultLazy = mapWithDefaultLazy;
/* No side effect */
